import { AfterViewInit, Component, HostListener, OnInit } from '@angular/core';
import { ApiService } from '../../../Services/api.service';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-content-dashboard',
  standalone: true,
  imports: [NzIconModule, RouterModule, CommonModule],
  templateUrl: './content-dashboard.component.html',
  styleUrl: './content-dashboard.component.scss'
})
export class ContentDashboardComponent implements OnInit, AfterViewInit {
  contentPageTypeData: any;
  zoomLevel: any = 100;
  contentImageMap: { [key: string]: string } = {
    'CO': 'Coordinator.png',
    'C1': 'FAQ.png',
    'FAQ': 'FAQ.png',
    'N': 'News.png',
    'ON': 'OnlineChat.png',
    'O': 'Overview.png',
    'S': 'FAQ.png',
    'W': 'Welcome.png',
    'NL': 'Navigation.png',
    'BI': 'PowerBi.png'
  };
  constructor(public apiService: ApiService) { }


  ngOnInit(): void {
    this.apiService.getContentPageType().subscribe(response => {
      response.forEach((node: any) => {
        const imageName = this.contentImageMap[node.pageType] || 'FAQ.png';
        Object.assign(node, { image: imageName });
      });

      this.contentPageTypeData = response;
    });
  }

  ngAfterViewInit(): void {
    this.zoomLevel = Math.round(window.devicePixelRatio * 100);
  }

  @HostListener('window:load', ['$event'])
  onLoad(event: Event): void {
    this.zoomLevel = Math.round(window.devicePixelRatio * 100);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.zoomLevel = Math.round(window.devicePixelRatio * 100);
  }
}
